import { GETTER_TRANSACTIONS, GET_IRA_INFLOW_OUTFLOW_TRANSACTIONS } from './types';

export default {
    [GETTER_TRANSACTIONS]: (state) => {
        return state.transactions;
    },
    [GET_IRA_INFLOW_OUTFLOW_TRANSACTIONS]: (state) => {
        return state.iraInflowOutflowTransactions;
    }
}